export default "__VITE_PUBLIC_ASSET__cdf44f9d__"